import * as types from './orderSupplierActionTypes';

// Get Order Supplier
export const getOrderSupplierRequest = (payload) => 
({ type: types.GET_ORDER_SUPPLIER_REQUEST, payload });
export const getOrderSupplierSuccess = (payload) => 
({ type: types.GET_ORDER_SUPPLIER_SUCCESS, payload });
export const getOrderSupplierError = (payload) => 
({ type: types.GET_ORDER_SUPPLIER_ERROR, payload });

// Add Order Supplier
export const addOrderSupplierRequest = (payload) => 
({ type: types.ADD_ORDER_SUPPLIER_REQUEST, payload });
export const addOrderSupplierSuccess = (payload) => 
({ type: types.ADD_ORDER_SUPPLIER_SUCCESS, payload });
export const addOrderSupplierError = (payload) => 
({ type: types.ADD_ORDER_SUPPLIER_ERROR, payload });

// Add Order Supplier Batch (for multiple rows)
export const addOrderSupplierBatchRequest = (payload) => 
({ type: types.ADD_ORDER_SUPPLIER_BATCH_REQUEST, payload });
export const addOrderSupplierBatchSuccess = (payload) => 
({ type: types.ADD_ORDER_SUPPLIER_BATCH_SUCCESS, payload });
export const addOrderSupplierBatchError = (payload) => 
({ type: types.ADD_ORDER_SUPPLIER_BATCH_ERROR, payload });

// Update Order Supplier
export const updateOrderSupplierRequest = (payload) => 
({ type: types.UPDATE_ORDER_SUPPLIER_REQUEST, payload });
export const updateOrderSupplierSuccess = (payload) => 
({ type: types.UPDATE_ORDER_SUPPLIER_SUCCESS, payload });
export const updateOrderSupplierError = (payload) => 
({ type: types.UPDATE_ORDER_SUPPLIER_ERROR, payload });

// Delete Order Supplier
export const deleteOrderSupplierRequest = (payload) => 
({ type: types.DELETE_ORDER_SUPPLIER_REQUEST, payload });
export const deleteOrderSupplierSuccess = (payload) => 
({ type: types.DELETE_ORDER_SUPPLIER_SUCCESS, payload });
export const deleteOrderSupplierError = (payload) => 
({ type: types.DELETE_ORDER_SUPPLIER_ERROR, payload });

// Get Order Supplier Dropdown
export const getOrderSupplierDropdownRequest = (payload) => 
({ type: types.GET_ORDER_SUPPLIER_DROPDOWN_REQUEST, payload });
export const getOrderSupplierDropdownSuccess = (payload) => 
({ type: types.GET_ORDER_SUPPLIER_DROPDOWN_SUCCESS, payload });
export const getOrderSupplierDropdownError = (payload) => 
({ type: types.GET_ORDER_SUPPLIER_DROPDOWN_ERROR, payload });

// Get Order Dropdown
export const getOrderDropdownRequest = (payload) => 
({ type: types.GET_ORDER_DROPDOWN_REQUEST, payload });
export const getOrderDropdownSuccess = (payload) => 
({ type: types.GET_ORDER_DROPDOWN_SUCCESS, payload });
export const getOrderDropdownError = (payload) => 
({ type: types.GET_ORDER_DROPDOWN_ERROR, payload });
